import { client as apiClient } from "./client";

apiClient.interceptors.request.use((request) => {
	request.headers.set("Storefront-Node-Id", document.documentElement.dataset["contentId"] ?? "");
	request.headers.set("Accept-Language", document.documentElement.lang);
	return request;
});

export * from "./client";
export const client = apiClient;
